<div class="pad-modal">
  <div class="pad-modal__header">
    <h2 class="pad-modal__title">Firma</h2>
    <button type="button" class="pad-modal__close" (click)="cancel()" aria-label="Cerrar">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  </div>

  <div class="pad-modal__body">
    <div class="pad-modal__canvas">
      <app-signature-pad
        [value]="data.initialValue || ''"
        [canvasWidth]="600"
        [canvasHeight]="300"
        [topReserveRatio]="0.25"
        (valueChange)="onValueChange($event)">
      </app-signature-pad>
    </div>
    <div class="workspace-actions pad-modal__actions">
      <button type="button" class="btn-outline-firma" (click)="cancel()">
        Cerrar
      </button>
      <button
        type="button"
        class="btn-primary-firma"
        [disabled]="!canSave"
        [class.btn-primary-firma--disabled]="!canSave"
        (click)="save()">
        Guardar
      </button>
    </div>
  </div>
</div>
